
import configJson from   '../../Config.json';
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

const s3Client = new S3Client({
       region: configJson.Region,
       credentials: {
           accessKeyId: configJson.AccessKey,
           secretAccessKey: configJson.SecretAccessKey,
       },
   });

export async function generatePresignedUrl(keyName,element,isBGIMG) {

       const params = new GetObjectCommand({
            Bucket: configJson.BucketName,
            Key: "HCM/" + keyName
        });
        
         const urlString = await getSignedUrl(s3Client, params,{ expiresIn: 3600 }); // URL valid for 1 hour
        
         if(isBGIMG){
            // var Celements = document.querySelectorAll(element);
            // Celements.forEach((dot, i) => {
            //     dot.setAttribute('background-image', `url(${urlString})`);
            // });
            return urlString;
         }
         else{
            const myImage = document.getElementById(element);
            myImage.src = urlString;
         }
}

